import * as React from 'react';
import ChatMessages from '../../../../services/dataKeepers/ChatMessages';
import cancelEvent from '../../../../services/mini/cancelEvent';
import { useCallback } from 'react';
import { chatIcons } from '../../../../../../alan_btn/src/assets/chatIcons';

export function StopResponseButton({ message }) {

    const handleClick = useCallback((e) => {
        ChatMessages.cancelResponse(message);

        cancelEvent(e);
    }, []);

    return <div className="stop-response-btn" onClick={handleClick}>
        <div className="stop-response-btn__ctrl" dangerouslySetInnerHTML={{ __html: chatIcons.msgLoader }}></div>
    </div>
}